import type React from 'react';

import { Image } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

import { SapCtas } from './components/SapCtas';
import { TitleAndTagline } from './components/TitleAndTagline';
import { TopImpactStoriesDesktop } from './components/TopImpactStoriesDesktop';
import { TopImpactStoriesMobile } from './components/TopImpactStoriesMobile';
import { TopImpactStoriesMobileProvider } from './components/TopImpactStoriesMobile/hooks/TopImpactStoriesMobileContext';

const BgImagePreload: React.FC<{ fetchPriority?: 'high' | 'low' | 'auto' }> = ({ fetchPriority }) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<Image
			src={getStaticAssetUrl('/homepageV3/background-globe-sunrise.svg')}
			alt="Globe"
			{...(fetchPriority ? { fetchPriority } : {})}
			className="absolute translate-x-0 -translate-y-[20%] overflow-visible bg-transparent object-cover max-md:h-full md:top-[15%] md:left-1/2 md:-translate-x-1/2 md:-translate-y-[30%]"
		/>
	);
};

export const HeroSection: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section data-testid="homepage-sunrise-hero-section" className="text-typography-strong relative overflow-hidden">
			<BgImagePreload fetchPriority="high" />

			<div className="relative z-10 container pt-6 md:pt-[44px] lg:pt-[60px] lg:pb-11">
				<div className="mt-3 space-y-6">
					<TitleAndTagline />
					<SapCtas />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop />}
			</div>

			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
